import actionCreatorFactory from 'typescript-fsa';
import { HintCreatePayload, HintEntity, NormalizedHint } from './hint.types';

const actionCreator = actionCreatorFactory('[HINT]');

export const updateHintAction = actionCreator.async<HintCreatePayload, HintEntity>('UPDATE');
export const feedHintAction = actionCreator.async<void, NormalizedHint>('FEED');
